import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { BlockingBase } from './Blocking'

import { isLoadingSelector, mainCitiesSelector } from 'reduxModules/selectors/CitySelectors'
import { routeIdSelector, isDisabledSelector } from 'reduxModules/selectors/RouteSelectors'
import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'
import { routeActions } from 'reduxModules/actions/RouteActions'
import { cityActions } from 'reduxModules/actions/CityActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  routeId: routeIdSelector,
  isPartner: isPartnerSelector,
  isLimitedDispatcher: isLimitedDispatcherSelector,
  isLoading: isLoadingSelector,
  mainCities: mainCitiesSelector,
  isDisabled: isDisabledSelector,
})

const mapDispatchToProps = {
  disableCity: cityActions.disableCity,
  disableRoute: routeActions.disableRoute
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const Blocking = enhance(BlockingBase)
 


// WEBPACK FOOTER //
// ./src/components/Blocking/index.js